<template>
  <highcharts :options="chartOptions" />
</template>

<script>
import {Chart} from 'highcharts-vue'
import moment from 'moment'

export default {
  name: 'ColumnsHistory',
  components: {
    highcharts: Chart
  },
  props: {
    dataChart: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  computed: {
    valueType () {
      return {
        'days': ' Dias',
        'percent': '%',
        'number': ''
      }[this.dataChart.value_type]
    },
    dateFormat () {
      return {
        // hour: {
        //   tickInterval: 3600 * 1000,
        //   // format: '%H:%M',
        //   moment: 'HH:mm',
        //   d: null
        // },
        day: {
          tickInterval: 24 * 3600 * 1000,
          // format: '%e. %b',
          moment: 'D. MMM',
          d: 'dayMonth'
        },
        // week: {
        //   tickInterval: 7 * 24 * 3600 * 1000,
        //   // format: '%e. %b',
        //   moment: 'D. MMM',
        //   d: 'dayMonth'
        // },
        month: {
          tickInterval: 30 * 24 * 3600 * 1000,
          // format: '%b \'%y',
          moment: 'MMM \'YY',
          d: 'monthYear'
        },
        year: {
          tickInterval: 12 * 30 * 24 * 3600 * 1000,
          // format: '%Y',
          moment: 'YYYY',
          d: null
        }
      }[this.dataChart.group_range]
    },
    chartOptions () {
      const _self = this

      return {
        chart: {
          type: 'column',
          height: 320,
          events: {
            click: function (event) {
              const point = this.series[0].searchPoint(event, true)
              _self.expand(point.options.filters, point.category)
            }
          },
          style: {
            cursor: 'pointer'
          }
        },
        title: {
          text: null
        },
        xAxis: {
          crosshair: true,
          ordinal: false,
          type: 'datetime',
          tickInterval: this.dateFormat.tickInterval,
          labels: {
            // format: `{value:${this.dateFormat.format}}`,
            formatter: (val) => {
              // const date = moment.tz(val.value, null, 'UTC')
              // if (this.dateFormat.d) {
              //   return this.$d(date.toDate(), this.dateFormat.d)
              // } else {
              //   return date.format(this.dateFormat.moment)
              // }
              return _self.foramtDate(val.value)
            }
          },
          title: {
            text: null
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: this.dataChart.metric_name
          }
        },
        tooltip: {
          shared: true,
          // headerFormat: `<b>{point.x:${this.dateFormat.format}}</b><br>`,
          formatter: function () {
            // const date = moment.tz(this.x, null, 'UTC').toDate()
            // console.log(this.points)
            return [
              `<b>${_self.foramtDate(this.x)}:</b>`,
              // `${_self.dataChart.metric_name}:`,
              this.points.map(item => `<span style="color:${item.series.color}">${item.series.name}</span>: ${item.y}${_self.valueType}`).join('<br>')
            ].join('<br>')
          }
          // pointFormat: `<span style="color:{series.color}">{series.name}</span>: <b>{point.y}${this.valueType}</b><br/>`
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: false
            }
          },
          series: {
            cursor: 'pointer',
            point: {
              events: {
                click: (a) => {
                  this.expand(a.point.options.filters, a.point.category)
                }
              }
            }
          }
        },
        legend: {
          // align: "right",
          enabled: true,
          layout: 'horizontal',
          maxHeight: 70
          // margin: 10,
          // useHTML: true,
          // verticalAlign: 'top',
          // x: 0,
          // y: 100
        },
        series: this.dataChart.series /* [{
        name: 'Winter 2014-2015',
        data: [
            [Date.UTC(1970, 1), 0],
            [Date.UTC(1970, 2), 0.25],
            [Date.UTC(1970, 3), 1.41],
            [Date.UTC(1970, 4), 1.64],
            [Date.UTC(1971, 5), 1.6],
            [Date.UTC(1971, 6), 2.55]
        ]
        }, {
        name: 'Winter 2015-2016',
        data: [
            [Date.UTC(1970, 1), 0],
            [Date.UTC(1970, 2), 0.25],
            [Date.UTC(1970, 3), 1.41],
            [Date.UTC(1970, 4), 1.64],
            [Date.UTC(1971, 5), 1.6],
            [Date.UTC(1971, 6), 2.55]
        ]
        }, {
        name: 'Winter 2016-2017',
        data: [
            [Date.UTC(1970, 1), 0],
            [Date.UTC(1970, 2), 0.25],
            [Date.UTC(1970, 3), 1.41],
            [Date.UTC(1970, 4), 1.64],
            [Date.UTC(1971, 5), 1.6],
            [Date.UTC(1971, 6), 2.55]
        ]
        }] */
      }
    }
  },
  created () {
  },
  methods: {
    foramtDate (timeUnix) {
      const secDiff = moment().zone() * 100000
      const date = moment.utc(timeUnix + secDiff).toDate()
      return this.$d(date, this.dateFormat.d)
    },
    expand (filters, timeUnix) {
      this.$emit('expand', {
        filters: filters,
        name: this.foramtDate(timeUnix)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ReportChart/ColumnsWithSegmentsHistory.vue